<template>
  <div class="checkout-product-item">
    <div class="checkout-product-item-image">
      <img :src="imageSrc" alt="product image" class="image" />

      <div v-if="showBadge" class="badge-container">
        <div class="badge">1</div>
      </div>
    </div>
    <div class="product-name">
      {{ item.name }}
    </div>
    <div class="price">
      <v-skeleton-loader
        v-if="isLoading"
        type="text"
        width="48px"
        class="price-skeleton"
      />
      <div v-else>
        <template v-if="item.final_bundle_price !== undefined">
          <template v-if="+item.final_bundle_price === 0">
            ฟรี
          </template>
          <template v-else>
            {{ item.final_bundle_price | currency2 }}
          </template>
          <div
            v-if="saveAmount(item.final_bundle_price) > 0"
            class="price-save"
          >
            ประหยัด ฿{{
              saveAmount(item.final_bundle_price) | currency2
            }}
          </div>
        </template>
        <template v-else>
          <template v-if="+resolvePrice() === 0">
            ฟรี
          </template>
          <template v-else>
            {{ resolvePrice() | currency2 }}
          </template>
          <div
            v-if="saveAmount(resolvePrice()) > 0"
            class="price-save"
          >
            ประหยัด ฿{{ saveAmount(resolvePrice()) | currency2 }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { resizeImage } from '@/utils/helpers'
import branchTypes from '@/config/branchTypes'

export default {
  name: 'CheckoutProductItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    branchType: {
      type: String,
      default: '',
    },
    cartDelivery: {
      type: String,
      default: '',
    },
    showBadge: {
      type: Boolean,
      default: true,
    },
    imageSize: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    imageSrc() {
      const url = this.item.imageUrl || this.item.image_url
      return this.imageSize > 0
        ? resizeImage(url, this.imageSize)
        : url
    },
  },
  methods: {
    // pick the price field to show based on branch type + delivery method
    resolvePrice() {
      if (this.branchType === branchTypes.BRANCH_TYPE_DEPOSIT) {
        return this.item.price_deposit
      }
      if (this.branchType === branchTypes.BRANCH_TYPE_FULL_PAYMENT) {
        return this.cartDelivery === 'store'
          ? this.item.price_store
          : this.item.price_ship
      }
      return this.item.price_ship
    },
    // amount saved off SRP versus the price actually shown
    saveAmount(price) {
      const srp = +this.item.price_srp
      if (!(srp > 0)) return 0
      return srp - +price
    },
  },
}
</script>

<style lang="stylus" scoped>
.checkout-product-item {
    display flex
    align-items center
    flex-wrap wrap
    gap 0 14px
}

.checkout-product-item-image {
    position relative
    width 64px
    height 64px
    border 1px solid rgb(214, 214, 214)
    border-radius 5px

    .image {
        width 100%
        height 100%

        object-fit contain
        object-position center
        border-radius 5px
    }
}

.product-name {
    position relative
    box-sizing border-box
    display block
    flex: 1
    min-height 21px
    margin-bottom 0px
    margin-left 0px
    margin-right 0px
    margin-top 0px
    width 284.195px
    text-size-adjust 100%
    font-size 14px
    font-weight 400
    letter-spacing normal
    line-height 21px
    text-transform none
    word-break break-word
    color rgb(0, 0, 0)
    margin-block-end 0px
    margin-block-start 0px
    margin-inline-end 0px
    margin-inline-start 0px
    overflow-wrap anywhere
    unicode-bidi isolate
}

.price {
    min-width 100px
    box-sizing border-box
    text-size-adjust 100%
    text-align right
    font-size 14px
    font-weight 400
    letter-spacing normal
    line-height 21px
    text-transform none
    text-wrap nowrap
    white-space-collapse preserve

    .price-save {
        display block
        font-size 12px
        color rgb(125, 125, 125)
    }

	.price-skeleton {
		margin-left auto
	}
}

.badge-container {
    position absolute
    top 0px
    right 0px
    transform: translate(25%, -50%);
}

.badge {
    align-items center
    box-sizing border-box
    display inline-flex
    height 22px
    justify-content center
    min-block-size 22px
    min-height 22px
    min-inline-size 22px
    min-width 22px
    padding-left 7px
    padding-right 7px
    width 22px
    text-size-adjust 100%
    font-size 12px
    font-weight 700
    letter-spacing normal
    line-height 18px
    text-transform none
    color rgb(245, 245, 245)
    background-color rgb(102, 102, 102)
    -webkit-font-smoothing subpixel-antialiased
    border-bottom-left-radius 36px
    border-bottom-right-radius 36px
    border-top-left-radius 36px
    border-top-right-radius 36px
    overflow-wrap break-word
    padding-inline-end 7px
    padding-inline-start 7px
    unicode-bidi isolate
}
</style>
